/**
 * Renders a list with optional prefix and indentation level.
 * @param {React.ReactNode} children - The content to render inside the list.
 * @param {string} [level='0'] - The indentation level of the list. Can be '0', '1', or '2'.
 * @param {string} [prefix] - An optional prefix to display before the list.
 * @returns {JSX.Element}
 */
export default function List({ children, level = '0', prefix }) {
  const padding = (level) => {
    switch (level) {
      case '0':
        return level;
      case '1':
        return '4';
      case '2':
        return '10';
    }
  };

  return (
    <>
      {prefix ? (
        <div className="flex flex-row gap-0.5">
          ({prefix})<ul className={`list-none pl-${padding(level)}`}>{children}</ul>
        </div>
      ) : (
        <ul className={`list-none pl-${padding(level)}`}>{children}</ul>
      )}
    </>
  );
}
